$(window).on("load", function () {
  // AOS Js
  AOS.init({
    easing: "ease-in-out-sine",
    offset: 10,
    disable: window.innerWidth <= 991
  });
});



$(document).ready(function () {

   $("a[href='#']").click(function (e) {
    e.preventDefault();
  });
  
  
	/*_____ FAQ's _____*/
  
	$(document).on("click", ".faqBlk > .head", function () {
		$(".faqBlk").not($(this).parent().toggleClass("active")).removeClass("active");
		$(".faqBlk > .txt").not($(this).parent().children(".txt").slideToggle()).slideUp();
	});
	$(".faqLst > .faqBlk:nth-child(1)").addClass("active");

	/*_____ runBtn _____*/
  
	$(".runBtn").on("click", function (event) {
		if (this.hash !== "") {
			event.preventDefault();
			var hash = this.hash;
			// console.log(hash);
			$("html, body").animate(
				{
					scrollTop: $(hash).offset().top - 0,
				},
				500
			);
		}
	});
  
  
  //   Whats Inside Slider 

  $('#slick-inside').slick({
    dots: true,
    fade: true,
    arrows: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false,
    swipe: false,
    swipeToSlide: false,
    customPaging: function (slick, index) {
      var targetImage = slick.$slides.eq(index).find('h3').text();
      return '<span>' + targetImage + '</span>';
    },
  });
  
  //   Review Slider

  $(".review-slider").slick({
    autoplay: false,
    dots: false,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    nextArrow: '<i class="fas fa-chevron-right slick-arrow arrow-right"></i>',
    prevArrow: '<i class="fas fa-chevron-left slick-arrow arrow-left"></i>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slideToScroll:1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slideToScroll:1
        }
      }
    ]
  });
  

  //   Product Slider


  $('.product-slider-main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.product-slider-nav'
  });
  $('.product-slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.product-slider-main',
    dots: false,
    focusOnSelect: true,
    nextArrow: '<i class="fal fa-chevron-right slick-arrow arrow-right"></i>',
    prevArrow: '<i class="fal fa-chevron-left slick-arrow arrow-left"></i>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slideToScroll:1

        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          slideToScroll:1

        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slideToScroll:1

        }
      }]
  });

  /*_____ accordionBlk _____*/
  $(document).on("click", ".accordionBlk .inner h4", function () {
    $(this).parent().toggleClass("active").children(".text").slideToggle();
  });
  $(".accordionBlk .inner:nth-child(1)").addClass("active");
  
  $("input[name='id']").change(function() {
    $('.product-slider-main .slick-track').find('.product-main-image-items').each( (index, element) => {
      var varient_id = $(element).attr('data-variant-image'); 
      var index = $(element).attr('data-slick-index'); 
      if($(this).val() == varient_id){
        $('.product-slider-main').slick('slickGoTo', index);
      }
    });
  });





//  video Section

	const $iframe = $(".video_blk iframe");
// const $videoContent = $(".videoContent");
let currentVideoSource;
let currentVideoSelected;
let currentContent;
let currentVideo;
let isCurrentVideoAutoplay;
function setSourceVideo(videoSource, autoPlay, videoSelected) {
  let video;
  if (videoSource == "youtube") {
    if (autoPlay == "yes") {
      return (video = `https://www.youtube.com/embed/${videoSelected}?feature=player&autohide=1&autoplay=1&rel=0`);
    } else {
      return (video = `https://www.youtube.com/embed/${videoSelected}?feature=player&autohide=1&rel=0`);
    }
  } else if (videoSource == "vimeo") {
    if (autoPlay == "yes") {
      video = `https://player.vimeo.com/video/${videoSelected}?autoplay=1`;
    } else {
      return (video = `https://player.vimeo.com/video/${videoSelected}`);
    }
  } else {
    return (video = videoSelected);
  }
}
function setVideo($iframe, video, content) {
  $iframe.attr("src", video);
//   $videoContent.append(`<p>${content}</p>`);
}

function getVideoData(el) {
  currentVideoSource = el.data("videosource");
  currentVideoSelected = el.data("videocode");
  currentContent = el.data("videocontent");
  isCurrentVideoAutoplay = el.data("autoplay");
}

$(".videoLink").on("click", function (event) {
  event.preventDefault();
  $(".videoLink").removeClass("active");
  $(this).addClass("active");
  $(".videoContent").empty();
  getVideoData($(this));
  currentVideo = setSourceVideo(
    currentVideoSource,
    isCurrentVideoAutoplay,
    currentVideoSelected
  );
  setVideo($iframe, currentVideo, currentContent);
});

function init() {
  let $firstvideo = $(".videoLink").first();
  getVideoData($firstvideo);
  currentVideo = setSourceVideo(
    currentVideoSource,
    isCurrentVideoAutoplay,
    currentVideoSelected
  );
  setVideo($iframe, currentVideo, currentContent);
}

init();

	$(document).on("click", "#learn_hub #hubTab li a", function () {
		
		init();
	});
  
  
});

// tab for desktop
function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}

// tab for mobile

$('.accordion-toggle').click(function(){
  $(this).next().toggleClass("open");
  $(this).find('i').toggleClass('fa-angle-down');
  $(this).find('i').toggleClass('fa-angle-up');
});
